import type { ModuleManifest } from '@botto/core';
import { routes } from './routes';
import { menu } from './menu';

/**
 * @botto/module-tracker — Tracker UI module.
 *
 * Domains lookup for SMS (GET /tracker/domains) is owned by module-sms.
 */
const manifest: ModuleManifest = {
  id: 'tracker',
  title: 'Трекер',
  routes,
  menu,
};

export default manifest;
